import { Heart } from "lucide-react";
import Logo from "@/components/Logo";

export default function Footer() {
  return (
    <footer className="border-t border-white/10 bg-night/60">
      <div className="mx-auto flex max-w-7xl flex-col items-center gap-6 px-4 py-12 text-center sm:px-8">
        <Logo />
        <p className="max-w-md text-sm text-paper/55">
          A magical Halloween coloring adventure. Tap, scribble, sparkle — made
          with boos & crayons.
        </p>
        <p className="flex items-center gap-1.5 text-xs text-paper/40">
          Boo Scribbles Coloring World <Heart size={11} className="text-candy" /> Happy
          Halloween
        </p>
      </div>
    </footer>
  );
}
